import { SOLAR_DATASET } from './solarDataset';

// Extract unique countries for the dropdown
export const COUNTRIES = [...new Set(SOLAR_DATASET.map(item => item.country))].map(name => {
  const regions = {
    'Nigeria': 'Africa', 'Ghana': 'Africa', 'Kenya': 'Africa', 'South Africa': 'Africa', 
    'Egypt': 'Africa', 'Rwanda': 'Africa', 'United Kingdom': 'Europe', 'Netherlands': 'Europe',
    'Germany': 'Europe', 'Spain': 'Europe', 'Italy': 'Europe', 'France': 'Europe',
    'United States': 'North America', 'Canada': 'North America',
    'United Arab Emirates': 'Middle East', 'India': 'Asia'
  };
  const symbols = {
    'United Kingdom': '£', 'Netherlands': '€', 'Germany': '€', 'Spain': '€', 'Italy': '€', 'France': '€',
    'Nigeria': '₦', 'Ghana': 'GH₵', 'Kenya': 'KSh', 'South Africa': 'R', 'Egypt': 'E£',
    'United States': '$', 'Canada': '$', 'United Arab Emirates': 'AED', 'India': '₹'
  };
  return { 
    name, 
    region: regions[name] || 'International', 
    symbol: symbols[name] || '$' 
  };
});

export const APPLIANCE_METADATA = {
  "Lights": { watts: 10, category: "Essentials" },
  "Refrigerator / Freezer": { watts: 150, category: "Essentials" },
  "WiFi / Internet": { watts: 15, category: "Essentials" },
  "Phone charging": { watts: 10, category: "Essentials" },
  "TV": { watts: 100, category: "Living" },
  "Fan": { watts: 60, category: "Living" },
  "Laptop / Computer": { watts: 60, category: "Living" },
  "Air Conditioner": { watts: 1500, category: "Cooling / Heating", highLoad: true },
  "Heater / Heat Pump": { watts: 2000, category: "Cooling / Heating", highLoad: true },
  "Microwave": { watts: 1200, category: "Kitchen", highLoad: true },
  "Electric kettle": { watts: 2000, category: "Kitchen", highLoad: true },
  "Stove / Oven": { watts: 3000, category: "Kitchen", highLoad: true },
  "Washing machine": { watts: 1000, category: "Laundry", highLoad: true },
  "Iron": { watts: 1500, category: "Laundry", highLoad: true },
  "Water pump": { watts: 750, category: "Water & Utilities", highLoad: true },
  "Water heater": { watts: 2000, category: "Water & Utilities", highLoad: true },
  "EV charger": { watts: 7000, category: "Advanced", highLoad: true },
  "Dishwasher": { watts: 1500, category: "Advanced", highLoad: true },
  "Air fryer": { watts: 1500, category: "Advanced", highLoad: true },
  "Security / CCTV": { watts: 50, category: "Advanced" }
};